module.exports = __webpack_public_path__ + "img/stay.64135885.png";